module.exports = __webpack_public_path__ + "static/img/wingman_logo.9d93468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wingman_logo.png
// module id = L8TL
// module chunks = 12